import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import Modal from '@mui/material/Modal';
import CircularProgress from '@mui/material/CircularProgress';

const ImageViewer = ({
  open,
  onClose,
  title,
  imageUrl,
  imageAlt,
  isLoading,
  imageUrlForBottom,
  imageAltForBottom,
  ledMultipleBoxesUrl,
  ledMultipleBoxesUrlForBottom
}) => {
  const [zoomLevel, setZoomLevel] = useState(1);

  const handleZoomIn = () => setZoomLevel((prev) => prev + 0.2);

  const handleZoomOut = () => {
    setZoomLevel((prev) => (prev > 0.2 ? prev - 0.2 : prev));
  };

  const handleClose = () => {
    setZoomLevel(1);
    onClose();
  };

  const hasLedImages = ledMultipleBoxesUrl || ledMultipleBoxesUrlForBottom;

  const renderImage = (src, alt) => {
    if (!src) {
      return (
        <div style={{ color: '#999', padding: '20px' }}>
          No image available
        </div>
      );
    }

    return (
      <div
        style={{
          flex: 1,
          border: '1px solid #ddd',
          borderRadius: '6px',
          backgroundColor: '#fafafa',
          padding: '12px',
          minHeight: 0
        }}
      >
        <div
          style={{
            width: 'fit-content',
            height: 'fit-content',
            margin: 'auto',
            overflow: 'hidden' 
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{
              display: 'block',
              transform: `scale(${zoomLevel})`,
              transformOrigin: 'top left', 
              transition: 'transform 0.2s ease',
              cursor: zoomLevel > 1 ? 'grab' : 'default'
            }}
          />
        </div>
      </div>
    );
  };

  return (
    <Modal open={open} onClose={handleClose}>
      <div
        style={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90vw',
          height: '90vh',
          backgroundColor: '#fff',
          borderRadius: '8px',
          boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        {/* ===== HEADER ===== */}
        <div
          style={{
            padding: '16px 20px',
            borderBottom: '1px solid #e0e0e0',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center'
          }}
        >
          <h2 style={{ margin: 0 }}>{title}</h2>

          <div style={{ display: 'flex', gap: '8px' }}>
            <IconButton onClick={handleZoomIn} size="small">
              <AddIcon />
            </IconButton>

            <IconButton onClick={handleZoomOut} size="small">
              <RemoveIcon />
            </IconButton>

            <IconButton onClick={handleClose} size="small">
              <CloseIcon />
            </IconButton>
          </div>
        </div>

        {/* ===== CONTENT ===== */}
        <div
          style={{
            flex: 1,
            padding: '20px',
            overflow: 'auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '20px'
          }}
        >
          {isLoading ? (
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100%'
              }}
            >
              <CircularProgress />
            </div>
          ) : (
            <>
              {/* ===== NORMAL IMAGES ===== */}
              {imageUrlForBottom ? (
                <div style={{ display: 'flex', gap: '20px', flex: 1 }}>
                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <h4>Top View</h4>
                    {renderImage(imageUrl, imageAlt)}
                  </div>

                  <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                    <h4>Bottom View</h4>
                    {renderImage(imageUrlForBottom, imageAltForBottom)}
                  </div>
                </div>
              ) : (
                <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                  {renderImage(imageUrl, imageAlt)}
                </div>
              )}

              {/* ===== LED IMAGES ===== */}
              {hasLedImages && (
                <div style={{ display: 'flex', gap: '20px', flex: 1 }}>
                  {ledMultipleBoxesUrl && (
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <h4>LED Top View</h4>
                      {renderImage(ledMultipleBoxesUrl, 'LED Top')}
                    </div>
                  )}

                  {ledMultipleBoxesUrlForBottom && (
                    <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                      <h4>LED Bottom View</h4>
                      {renderImage(ledMultipleBoxesUrlForBottom, 'LED Bottom')}
                    </div>
                  )}
                </div>
              )}
            </>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default ImageViewer;